<template>
  <i18n-t keypath="NotificationsComponent.ValidationError_AMZSLicense" tag="span" class="pl-quarter" scope="global">
    <template #link>
      <button class="inline-btn-link" type="button" @click="goToUrl()">
        {{ t("NotificationsComponent.ValidationError_AMZSLicense_link") }}
      </button>
    </template>
  </i18n-t>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { t } from "@/i18n";
import { getUrl } from "@/common/getUrl";

const componentName = "AMZSErrorNotification";

export default defineComponent({
  name: componentName,
  setup() {
    function goToUrl() {
      window.open(getUrl("AMAZON_MEMBERSHIP_URL"), "_blank");
    }

    return { t, goToUrl };
  },
});
</script>
